import { render } from "./DefaultText.vue?vue&type=template&id=67e864c6"
const script = {}
script.render = render

export default script